<ng-container *ngIf="noiseForm">
  <h4 class="wizard-h3">What is the noise level that CurbNTurfers can expect at the site?</h4>
  <div class="_12-px-spacer"></div>
  <div class="button-wrapper-grid">
    <div class="cnt-button-extended">
      <label [ngClass]="{ active: level.value === 'silence' }" title="Silence" class="cnt-button">
        <input type="radio" value="silence" [formControl]="level" [containerElement]="noiseError" />
        <span class="cnt-button-copy">Silence</span>
      </label>
      <div *ngIf="level.value === 'silence'">
        <label for="silenceDescription" class="sr-only"> Silence Description </label>
        <textarea class="semi-rounded" id="silenceDescription" [formControl]="description" placeholder="Please describe..."></textarea>
      </div>
    </div>
    <div class="cnt-button-extended">
      <label [ngClass]="{ active: level.value === 'nature' }" title="Sounds of Nature" class="cnt-button">
        <input type="radio" value="nature" [formControl]="level" [containerElement]="noiseError" />
        <span class="cnt-button-copy">Sounds of Nature</span>
      </label>
      <div *ngIf="level.value === 'nature'">
        <textarea class="semi-rounded" id="natureDescription" [formControl]="description" placeholder="Please describe..."></textarea>
      </div>
    </div>
    <div class="cnt-button-extended">
      <label [ngClass]="{ active: level.value === 'periodic' }" title="Periodic Sounds" class="cnt-button">
        <input type="radio" value="periodic" [formControl]="level" [containerElement]="noiseError" />
        <span class="cnt-button-copy">Periodic Sounds</span>
      </label>
      <div *ngIf="level.value === 'periodic'">
        <label for="periodicDescription" class="sr-only"> Periodic Noise Description </label>
        <textarea class="semi-rounded" id="periodicDescription" [formControl]="description" placeholder="Please describe..."></textarea>
      </div>
    </div>
    <div class="cnt-button-extended">
      <label [ngClass]="{ active: level.value === 'constant' }" title="Constant Noise" class="cnt-button">
        <input type="radio" value="constant" [formControl]="level" [containerElement]="noiseError" />
        <span class="cnt-button-copy">Constant Noise</span>
      </label>
      <div *ngIf="level.value === 'constant'">
        <label for="constantDescription" class="sr-only"> Constant Noise Description </label>
        <textarea class="semi-rounded" id="constantDescription" [formControl]="description" placeholder="Please describe..."></textarea>
      </div>
    </div>
  </div>
  <p *ngIf="noiseErrorString" class="alert-danger">
    <i class="icon-cnt-times-circle"></i>
    {{ noiseErrorString }}
  </p>
  <div class="noise-error">
    <div #noiseError="curbnturfDisplayValidationErrorsContainerRef" curbnturfDisplayValidationErrorsContainer></div>
  </div>
</ng-container>
